"use client";
import Link from "next/link";
import Image from "next/image";
import { TJobs } from "@/modules/job-board/types";
import { ArrowRight } from "lucide-react";

export const JobCard = ({
	location,
	logo,
	title,
	isRemote,
	duration,
	applyLink,
	company,
}: TJobs) => {
	return (
		<div className="shadow-[0px 4px 14px 0px rgba(0, 0, 0, 0.02)] mb-4 max-w-md rounded-lg border border-[#EEEDF0] bg-white">
			<div className=" items-center justify-between sm:flex">
				<div className="px-4 py-4 md:px-5 md:py-5 ">
					<div className="flex items-center">
						<Image
							src={logo}
							alt={`${company} logo`}
							className="mr-3.5 h-16 w-16 flex-shrink-0 overflow-hidden rounded-md border border-gray-300 object-contain"
							width={200}
							height={200}
						/>

						<div>
							<p className="text-textColorLight mb-1 text-sm leading-none ">{company}</p>
							<h5 className="mb-1.5 text-base font-semibold leading-none md:leading-none">
								{title}
							</h5>
							<div className=" flex flex-wrap items-center gap-2 md:gap-4">
								<div className="max-w-[200px]">
									<h5 className="truncate text-sm">{location}</h5>
								</div>

								<div className="flex items-center gap-2">
									{isRemote && (
										<div className="flex w-max items-center gap-1 rounded-full border border-gray-300 px-2 py-1 text-xs text-gray-600">
											<Image
												src="/assets/img/icons/earth-1.svg"
												alt="Remote Icon"
												width={20}
												height={20}
												className="h-3 w-3"
											/>
											Remote
										</div>
									)}

									<div className="flex w-max items-center gap-1 rounded-full border border-gray-300 px-2 py-1 text-xs text-gray-600">
										<Image
											src="/assets/img/icons/full-time-icon.svg" 
											alt="Duration Icon"
											width={20}
											height={20}
											className="h-3 w-3"
										/>
										{duration}
									</div>
								</div>
							</div>
							<Link
								href={applyLink}
								target="_blank"
								className="hover:opcaity-50 mt-2 flex items-center gap-1 text-sm font-semibold leading-none text-brand-primary"
							>
								View Details
								<ArrowRight className="h-4 w-4" />
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
